<template>
  <div class="patient-intro-video">
    <video
      ref="video"
      class="patient-intro-video__media"
      :src="videoSrc"
      autoplay
      muted
      playsinline
      @ended="$emit('ended')"
      @error="$emit('ended')"
    ></video>
  </div>
</template>

<style lang="scss" scoped>
.patient-intro-video {
  display:                        flex;
  flex:                           1;
  min-height:                     0;
  background:                     #000;
}

.patient-intro-video__media {
  width:                          100%;
  height:                         100%;
  object-fit:                     cover;
}
</style>

<script>
import patientModeVideo from '@/assets/videos/ai-assistant/patient-mode.mp4'

export default {
  name: 'ExamAiAssistantPatientIntroVideo',
  emits: ['ended'],
  data: () => ({
    videoSrc: patientModeVideo,
  }),
  // Muted autoplay can still be blocked by an unusual browser setting — if play() itself
  // rejects, there's no @ended to fall back on either, so this tab would get stuck on a
  // frozen first frame forever. Treating that failure the same as "video's done" keeps the
  // intro moving instead of trapping the doctor on a screen with no visible way forward.
  mounted() {
    this.$refs.video?.play?.()?.catch(() => this.$emit('ended'))
  },
}
</script>
